import * as yup from "yup";

export const underdotsCommonSchema = {
  radarMake: yup.string(),
  collectionDate: yup.string(),
  cors: yup.string(),
  collectionParameters: yup.string(),
  surfaceWet: yup.string(),
  preProcessed: yup.string(),
  radarPositioningMethod: yup.string(),
  postProcessed: yup.string(),
  softwareUsed: yup.string(),
  notes: yup.string(),
  radarSampleDepth: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value)),
  sampleDataType: yup.string(),
  elevationModel: yup.string()
};

export const underdotsPublicSchema = {
  fullName: yup.string().required("Please enter your full name"),
  email: yup.string().email().required("Please enter your email address"),
  dataLink: yup
    .string()
    .url()
    .required("Please enter the URL of where your radar files are hosted"),
  ...underdotsCommonSchema
};
